import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { Column } from '../../../interfaces';

@Pipe({
  name: 'tooltipText',
  standalone: true,
})
export class TooltipTextPipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  /**
   * Verificar se possui tooltip e efetuar a tradução
   * @param column Coluna da tabela
   */
  transform(column?: Column): string {
    return column?.icon?.tooltip?.text ? this.translocoService.translate(column.icon.tooltip.text) : '';
  }
}
